import React, { useState, useEffect, useRef } from 'react';
import { DialogContent, DialogOverlay } from '@reach/dialog';
import clsx from 'clsx';

import styles from './BottomDrawer.module.scss';
import { Container } from '@/containers';

const BottomDrawer = ({ isOpen, onClose, children }) => {
	const [isShownContent, setIsShownContent] = useState(true);
	const [isShownDialog, setIsShownDialog] = useState(false);
	const dialogRef = useRef(null);

	const close = () => {
		setIsShownContent(false);
		setTimeout(() => {
			setIsShownDialog(false);
		}, 300);
	};

	const open = () => {
		setIsShownContent(true);
		setIsShownDialog(true);
	};

	useEffect(() => {
		if (isOpen) {
			open();
		} else {
			close();
		}
	}, [isOpen]);

	return (
		<DialogOverlay
			isOpen={isShownDialog}
			aria-label={undefined}
			className={styles.root}
			onClick={onClose}
		>
			<DialogContent aria-labelledby='cookies details' className={styles.dialog}>
				<div
					id='drawer-container'
					ref={dialogRef}
					className={clsx({
						[styles['drawer-content']]: true,
						[styles.hide]: !isShownContent,
					})}
				>
					<Container>
							<div className={styles.contentBlock}>{React.cloneElement(children, { onClose: close })}</div>
					</Container>
				</div>
			</DialogContent>
		</DialogOverlay>
	);
};

export default BottomDrawer;
